import { CommonModule } from '@angular/common';
import { assertInInjectionContext, Component, inject, OnInit } from '@angular/core';
import { ChildQuery, ChildService, ChildViewModel } from '@fgb/core';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { Observable } from 'rxjs';
import { GuardianModule } from 'src/app/modules/guardian/guardian.module';

export function getChildrenInfo(): Observable<{ data: ChildViewModel[]; free: ChildViewModel[]; empty: any[]; limit: number }> {
  assertInInjectionContext(getChildrenInfo);
  return inject(ChildQuery).getChildrenInfo();
}
@Component({
  selector: 'fgb-guardian-page',
  templateUrl: './guardian-page.component.html',
  standalone: true,
  imports: [FGBSharedModule, CommonModule, DirectivesModule, GuardianModule],
  styleUrls: ['./guardian-page.component.scss']
})
export class GuardianPageComponent implements OnInit{
  children$ = getChildrenInfo();

  constructor(private childService: ChildService) {}

  ngOnInit() {
    this.childService.disableChildStoreCache();
  }

}
